import {css} from "lit";

export const countIndicatorStyles = css`
	.count-indicator {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		margin-left: 9px;
		border-radius: 50%;
		font-weight: bold;
		font-size: var(--pn-font-size-small);
		line-height: 0;
		text-align: center;
		color: var(--pn-outline-count-number-color);
		width: 23px;
		height: 23px;
	}
	.count-indicator.big {
		font-size: 13px;
	}
	.count-indicator.big:before {
		padding-top: 58%;
	}

	.count-indicator.extra-big {
		font-size: 10px;
	}
	.count-indicator.extra-big:before {
		padding-top: 50%;
	}
`;
